var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 80 30",
    width: "80px",
    height: "30px",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 58.813 21.921 L 64.919 21.921 L 80 0.842 L 74.688 0.842 L 58.813 21.921 L 58.813 21.921 Z ",
    fill: "rgb(111,199,233)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 45.488 11.572 C 45.487 12.104 45.448 12.636 45.369 13.162 L 28.934 13.101 C 29.243 14.941 30.506 16.056 31.437 16.74 C 32.368 17.424 33.83 17.663 35 17.663 C 36.619 17.663 38.531 16.777 39.594 15.503 L 42.142 19.338 C 40.194 21.237 37.571 22.283 34.85 22.245 Q 30.386 22.245 27.269 19.143 Q 24.152 16.042 24.17 11.587 Q 24.17 7.171 27.302 4.071 Q 30.433 0.971 34.85 0.969 Q 39.272 0.969 42.381 4.066 Q 45.489 7.163 45.488 11.572 Z  M 40.467 9.024 C 39.47 6.801 37.265 5.366 34.829 5.355 C 32.243 5.355 30.041 6.861 29.169 9.024 L 40.467 9.024 Z ",
    fill: "rgb(18,150,212)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 50.06 4.18 C 52.191 2.06 57.397 -1.183 64.465 2.973 L 61.346 6.552 C 57.046 4.49 54.78 6.375 53.791 7.438 C 52.637 8.65 52.121 10.034 52.056 11.74 L 52.056 22.181 L 46.861 22.191 L 46.861 11.885 Q 46.861 7.356 50.06 4.18 Z ",
    fill: "rgb(18,150,212)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 6.507 9.314 C 7.123 7.843 8.285 6.667 9.749 6.034 C 11.287 5.381 13.024 5.381 14.562 6.034 C 15.291 6.348 15.954 6.799 16.513 7.362 C 17.071 7.924 17.518 8.585 17.832 9.312 C 18.475 10.827 18.475 12.539 17.832 14.054 C 17.209 15.53 16.042 16.711 14.573 17.35 C 13.035 18.003 11.297 18.003 9.759 17.35 C 9.034 17.038 8.375 16.59 7.817 16.032 C 7.263 15.469 6.82 14.807 6.51 14.08 C 5.868 12.558 5.868 10.841 6.51 9.319 L 6.507 9.314 Z  M 16.48 21.415 C 17.762 20.845 18.919 20.028 19.885 19.012 Q 22.926 15.88 22.84 11.458 C 22.824 10.061 22.532 8.68 21.982 7.395 C 21.421 6.122 20.606 4.976 19.587 4.028 C 17.451 1.996 14.933 1.073 12.03 1.073 C 9.365 1.073 6.604 1.831 4.284 4.205 C -4.702 12.529 3.239 29.158 3.239 29.158 L 7.671 26.539 C 6.648 24.311 5.805 22.005 5.149 19.643 C 7.534 21.845 10.217 22.303 12.454 22.268 C 13.839 22.253 15.208 21.963 16.48 21.415 Z ",
    fill: "rgb(18,150,212)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 78.937 22.181 L 73.013 22.181 L 63.243 8.636 L 66.465 4.847 L 78.937 22.181 L 78.937 22.181 Z ",
    fill: "rgb(18,150,212)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: " M 27.165 24.905 L 42.462 24.905 L 39.338 29.046 L 24.045 29.046 L 27.165 24.905 Z ",
    fill: "rgb(240,90,35)"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_logo.2145aac9f61bead9ceb1c757e3d9401a.svg";